export function Logo({ compact = false }: { compact?: boolean }) {
  return <div className={`brand ${compact ? "compact" : ""}`} aria-label="Positronico">
    <span className="brand-mark"><span/></span>{!compact && <strong>POSITRONICO</strong>}
  </div>;
}
